module.exports = __webpack_public_path__ + "static/media/5630.30ec1ee2.jpg";